import React, { Component } from 'react'
import { connect } from 'react-redux'
import FontAwesome from 'react-fontawesome'

import Modal from '../Shared/Modal'
import ModalHeader from '../Shared/ModalHeader'
import ModalBody from '../Shared/ModalBody'
import ModalFooter from '../Shared/ModalFooter'

import {
    showHideModalMsgBox
} from '../../actions/common'

class ModalMsgBox extends Component {
    handleCloseModal = (e) => {
        const modal = document.getElementById('modalMsgBox')
        modal.classList.remove('fadeIn')
        modal.classList.add('fadeOut')

        const modalDialog = document.querySelector(`#modalMsgBox .modal-dialog`)
        modalDialog.classList.remove('zoomIn')
        modalDialog.classList.add('zoomOut')

        setTimeout(() => this.props.showHideModalMsgBox(false), 300)
    }

    renderMessage = (width, message) => {
        if (width === 500) {
            return (
                <div className="row">
                    <div className="col-sm-2" style={{ textAlign: 'right' }}>
                        <FontAwesome style={{ color: '#C00000', fontSize: '3em' }} name="exclamation-circle" />
                    </div>
                    <div className="col-sm-10" style={{ whiteSpace: 'pre-line', maxHeight: '200px', overflow: 'scroll', fontSize: '14px', fontWeight: '300' }}>
                        <div>{ message }</div>
                    </div>
                </div>
            )
        } else {
            return (
                <div className="row">
                    <div className="col-sm-12" style={{ whiteSpace: 'pre-line', maxHeight: '600px', overflow: 'scroll' }}>
                        <div dangerouslySetInnerHTML={{__html: message}} />
                    </div>
                </div>
            )
        }
    }

    render() {
        const { modalMsgBox } = this.props
        if (!modalMsgBox.get('show')) {
            return null
        }
        const message = modalMsgBox.get('message')
        let width = 500
        if (message.startsWith('<!DOCTYPE html>')) width = 1300
        return(
            <Modal id="modalMsgBox" show={ true } width={width}>
                <ModalHeader title="Ha ocurrido un error" onClose={ (e) => this.handleCloseModal(e) } />
                <ModalBody>
                    <div>
                        {this.renderMessage(width, modalMsgBox.get('message'))}
                    </div>
                </ModalBody>
                <ModalFooter>
                    <button className="btn btn-default" type="button" onClick={ (e) => this.handleCloseModal(e) }>Aceptar</button>
                </ModalFooter>
            </Modal>
        )
    }
}

const mapStateToProps = (state, onwProps) => {
    return {
        modalMsgBox: state.common.get('msgBox')
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        showHideModalMsgBox: () => dispatch(showHideModalMsgBox())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalMsgBox)



// WEBPACK FOOTER //
// ./src/components/Layout/MsgBox.jsx